import { CountryIconProps } from './types';

const GW = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3634)">
      <path
        d="M12.0001 -0.00012207C10.917 -0.00012207 9.86772 0.144253 8.86961 0.413269L7.82617 11.9999L8.86966 23.5865C9.86772 23.8555 10.917 23.9999 12.0001 23.9999C18.6274 23.9999 24.0001 18.6273 24.0001 11.9999C24.0001 5.3725 18.6274 -0.00012207 12.0001 -0.00012207Z"
        fill="#FFDA44"
      />
      <path
        d="M7.82617 12.0005L8.86966 23.5871C9.86772 23.8561 10.917 24.0005 12.0001 24.0005C18.6274 24.0005 24.0001 18.6279 24.0001 12.0005H7.82617Z"
        fill="#6DA544"
      />
      <path
        d="M0 11.9994C0 16.5479 2.53078 20.5051 6.26086 22.5403V1.4585C2.53078 3.49372 0 7.4509 0 11.9994Z"
        fill="#D80027"
      />
      <path
        d="M0 11.9995C0 17.5438 3.76036 22.2091 8.86955 23.5861V0.412842C3.76036 1.78984 0 6.45512 0 11.9995Z"
        fill="#D80027"
      />
      <path
        d="M4.53468 8.86841L5.31163 11.2598H7.82629L5.79201 12.7378L6.56891 15.1293L4.53468 13.6513L2.50035 15.1293L3.27745 12.7378L1.24316 11.2598H3.75768L4.53468 8.86841Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3634">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GW;
